import { ActionReducerMap, createSelector, createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { SubscriptionsState, reducer, getsubscriptions, getloading } from './subscriptions.reducer';
import {Subscription} from './subscriptions.model';
export interface SubscriptionsModuleState {
  subscriptionsState: SubscriptionsState;
}

export const /** @type {?} */ reducers: ActionReducerMap<SubscriptionsModuleState> = {
  subscriptionsState: reducer,
};

export  const /** @type {?} */ selectFeatureModule = createFeatureSelector<SubscriptionsModuleState>('subscriptions');
export  const /** @type {?} */ selectFeatureState = createSelector(selectFeatureModule, (state: SubscriptionsModuleState) => state.subscriptionsState);

export  const /** @type {?} */ getSubscriptionsStateSubscriptions = createSelector(selectFeatureState, getsubscriptions);
export  const /** @type {?} */ getSubscriptionsStateLoading = createSelector(selectFeatureState, getloading);
